import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_MY_APPLICATIONS ({ commit }, formData) {
    const query = `query userGesuche($order_by: MyGesucheSort) {
      userGesuche(order_by: $order_by) {
        antragId
        gesuchArt
        erstelltAm
        gesuchKey
        adresse
        status
        statusId
        gesuchArtAbkuerzung
        eingangsdatum
        eingangAusfuehrungBestaetigungDatum
        gemeinde
        gemeindeId
        gesuchArt
        gesuchId
        gesuchsartId
        letzteAenderungAm
        eigentuemer {
          fullname
        }
        kontaktPerson {
          vorname
          name
          email
        }
      }
    }`

    const variables = {
      order_by: {
        gesuchId: 'DESC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_MY_APPLICATIONS', data.data.userGesuche)
    }
    return data
  },
  async GET_APPLICATION_BY_ID ({ commit }, applicationId) {
    const query = `query userGesucheById($gesuchId: Int!) {
      userGesucheById(gesuchId: $gesuchId) {
        antragId
        gesuchArt
        erstelltAm
        gesuchKey
        adresse
        statusId
        status
        gesuchArtAbkuerzung
        eingangsdatum
        eingangAusfuehrungBestaetigungDatum
        eingangZusicherung
        gemeinde
        gemeindeId
        gesuchArt
        gesuchId
        gesuchsartId
        letzteAenderungAm
        projektabschlussAuswahl
        gesuch {
          name
          value
        }
        objekt {
          name
          value
        }
        eigentuemer {
          vorname
          name
          strasse
          hausNr
          plz
          ort
          telefon
          email
        }
        kontaktPerson {
          vorname
          name
          strasse
          hausNr
          plz
          ort
          telefon
          email
        }
        zusicherung {
          betragGemeinde
          betragKanton
          firstAblauf
        }
      }
    }`

    const variables = {
      gesuchId: Number(applicationId)
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_APPLICATION_PROPERTY_TYPES ({ rootState, state, commit }) {
    const { propertyCommunityId } = rootState.application.createApplication

    const query = `query gesuchsArten(
      $input: GesuchsArtenInput!
      $order_by: GesuchsArtSort
      $where: GesuchsArtFilter
    ){
      gesuchsArten(input: $input order_by: $order_by where: $where) {
        abkuerzung
        bezeichnung
        codeName
        id
      }
    }`

    const variables = {
      input: {
        gemeindeId: propertyCommunityId
      },
      where: {
        isObjektRequired: true
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_APPLICATION_PROPERTY_TYPES', data.data.gesuchsArten)
    }

    return data
  },
  async GET_APPLICATION_ADVANCED_TYPES ({ rootState, state, commit }) {
    const { advancedCommunityId } = rootState.application.createApplication

    const query = `query gesuchsArten(
      $input: GesuchsArtenInput!
      $order_by: GesuchsArtSort
      $where: GesuchsArtFilter
    ){
      gesuchsArten(input: $input order_by: $order_by where: $where) {
        abkuerzung
        bezeichnung
        codeName
        id
      }
    }`

    const variables = {
      input: {
        gemeindeId: advancedCommunityId
      },
      where: {
        isObjektRequired: false
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_APPLICATION_ADVANCED_TYPES', data.data.gesuchsArten)
    }

    return data
  },
  async GET_APPLICATION_FORM ({ rootState, commit, dispatch }) {
    const { finalCommunityId, finalApplicationType } = rootState.application.createApplication

    const query = `query GetGesuchFormByCode($input: GesucheFormInput!) {
      gesuchFormByCode(input: $input) {
        gemeindeId
        gesuchsartBezeichnung
        gesuchsartCode
        tabs{
          tag
          title
          formFields {
            title
            formGroups{
              sizes{
                ...sizeInfo
              }
              ...labelInfo
              fields{
                ...fieldInfo
                sizes{
                  ...sizeInfo
                }
                subFields{
                  ...labelInfo
                  fields{
                    ...fieldInfo
                    sizes{
                     ...sizeInfo
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    fragment labelInfo on FormGroupModel{
      label {
        for
        text
        sizes{
          ...sizeInfo
        }
      }
    }

    fragment fieldInfo on FieldModel{
      id
      appendedText
      defaultValue
      fieldType
      format
      helpText
      maxLength
      placeholder
      rule
    }

    fragment sizeInfo on GridModel{
      col
      colLg
      colMd
      colSm
      colXl
    }`

    const variables = {
      input: {
        gemeindeId: finalCommunityId,
        gesuchCode: finalApplicationType
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_APPLICATION_FORM_FIELDS', data.data.gesuchFormByCode)
    }

    return data
  },
  async SAVE_APPLICATION_FORM ({ rootState, state, commit, dispatch }, draftId) {
    const {
      applicationPropertyType,
      finalCommunityId,
      finalApplicationType,
      propertyId,
      correspondence
    } = rootState.application.createApplication

    const {
      personId,
      personContactId
    } = rootState.application.createApplication.formData

    let resPerson
    let resPersonContact
    let resProperty

    let dataPerson
    let dataPersonContact
    let dataProperty = {}

    try {
      /* GET Person (Gesuchsteller) */
      if (personId !== -1) {
        resPerson = await dispatch('person/GET_PERSON_BY_ID', { personId, includeOrganisation: true }, {
          root: true
        })
        dataPerson = resPerson.data.userPersonById
      } else {
        resPerson = await dispatch('profile/GET_PRFOFILE', {}, {
          root: true
        })
        const { userProfile } = resPerson.data
        const { email, userProfile: profileData } = userProfile
        dataPerson = { email, ...profileData }
      }

      /* GET Person Contact (Kontaktperson) */
      if (personContactId !== -1) {
        resPersonContact = await dispatch('person/GET_PERSON_BY_ID', { personId: personContactId, includeOrganisation: true }, {
          root: true
        })
        dataPersonContact = resPersonContact.data.userPersonById
      } else {
        resPersonContact = await dispatch('profile/GET_PRFOFILE', {}, {
          root: true
        })
        const { userProfile } = resPersonContact.data
        const { email, userProfile: profileData } = userProfile
        dataPersonContact = { email, ...profileData }
      }

      /* GET all Data for Property Actions */
      if (applicationPropertyType) {
        resProperty = await dispatch('property/GET_PROPERTY_BY_ID', { propertyId, includeOrganisation: true }, {
           root: true
        })
        dataProperty = resProperty.data.liegenschaftById
      }

      const { formData } = state.createApplication

      const eigentuemer = Object.keys(dataPerson).map(key => {
        const value = dataPerson[key]
        return { name: key, value: value }
      })

      const kontaktPerson = Object.keys(dataPersonContact).map(key => {
        const value = dataPersonContact[key]
        return { name: key, value: value }
      })

      const objekt = Object.keys(dataProperty).map(key => {
        const value = dataProperty[key]
        return { name: key, value: value }
      })

      const gesuch = Object.keys(formData.gesuch).map(key => {
        const value = formData.gesuch[key]
        return { name: key, value: value }
      })

      const query = `mutation antragCreate($input: AntragCreateInput!) {
        antragCreate(input: $input) {
          gesuch{
            adresse
            antragId
            eingangsdatum
            erstelltAm
            gesuchKey
            gemeinde
            gemeindeId
            gesuchArt
            gesuchId
            gesuchsartId
            letzteAenderungAm
            status
            statusId
            eigentuemer {
              fullname
            }
          }
        }
      }`

      const variables = {
        input: {
          antragDraftId: Number(draftId),
          gemeindeId: finalCommunityId,
          gesuchCode: finalApplicationType,
          eigentuemer,
          kontaktPerson,
          objekt,
          gesuch,
          korrespondenz: correspondence
        }
      }

      const { data } = await gql({ query, variables })

      if (!data.errors) {
        commit('SET_NEW_APPLICATION', data.data.antragCreate.gesuch)

        if (draftId) {
          commit('draft/DELETE_DRAFT', draftId, { root: true })
        }
      }

      return data
    } catch (err) {
      console.error('err', err)
    }
  }
}
